module.exports = __webpack_public_path__ + "static/media/meteringcase02.67113eab.png";